/**
 * Cap nested header menu lists at 8 links and append a Show more link.
 */
(() => {
  const moduleSelector = '.menu.expanded .catalog';
  const catalogs = document.querySelectorAll(moduleSelector);
  if (!catalogs.length) return;

  const MAX_LINKS = 8;

  const addShowMore = (parent, href) => {
    if (!href || parent.querySelector(':scope > a.see-more-link, :scope > .see-more, :scope > li.see-more')) return;

    const seeMore = document.createElement('a');
    seeMore.classList.add('see-more-link');
    seeMore.href = href;
    seeMore.textContent = 'Show more';
    parent.append(seeMore);
  };

  const hasNestedLinks = (group) => {
    const childUl = group.querySelector(':scope > ul');
    if (!childUl) return false;
    return childUl.querySelectorAll(':scope > li:not(.hide)').length > 0;
  };

  const wrapSideLinks = (container) => {
    if (container.querySelector(':scope > .submenu-side')) return;

    const sideItems = [...container.children].filter((item) => (
      item.matches('li') && !hasNestedLinks(item)
    ));
    if (!sideItems.length) return;

    const wrap = document.createElement('div');
    wrap.className = 'submenu-side';
    sideItems.forEach((item) => wrap.appendChild(item));
    container.appendChild(wrap);
  };

  try {
    catalogs.forEach((catalog) => {
      catalog.querySelectorAll(':scope > li.has-submenu').forEach((navItem) => {
        const container = navItem.querySelector(':scope > .submenu .submenucontainer, :scope > .submenucontainer');
        if (!container) return;

        const nestedGroups = [...container.querySelectorAll(':scope > li.has-submenu')].filter(hasNestedLinks);

        if (nestedGroups.length >= 3) {
          navItem.classList.add('js-mega-menu');
        } else if (nestedGroups.length >= 1) {
          navItem.classList.add('js-compact-menu');
          wrapSideLinks(container);
        }
      });

      catalog.querySelectorAll('.submenucontainer > li.has-submenu').forEach((group) => {
        const parentLink = group.querySelector(':scope > a');
        const childUl = group.querySelector(':scope > ul');
        if (!parentLink?.href || !childUl) return;
        if (!hasNestedLinks(group)) return;

        addShowMore(group, parentLink.href);
      });

      catalog.querySelectorAll('.submenucontainer').forEach((container) => {
        if (container.closest('.js-mega-menu, .js-compact-menu')) return;

        const items = container.querySelectorAll(':scope > li:not(.hide):not(.see-more)');
        if (items.length <= MAX_LINKS) return;

        const parentNav = container.closest('.catalog > li.has-submenu');
        const parentLink = parentNav?.querySelector(':scope > a');
        if (!parentLink?.href) return;

        if (container.querySelector(':scope > li.see-more, :scope > a.see-more-link')) return;

        const seeMoreLi = document.createElement('li');
        seeMoreLi.classList.add('see-more');
        addShowMore(seeMoreLi, parentLink.href);
        container.append(seeMoreLi);
      });
    });
  } catch (error) {
    console.error(`Error: ${moduleSelector}`, error);
  }
})();

/**
 * Pin .faded-bg to the red nav bar's bottom and the viewport edges.
 * Platform JS uses $('header').height(), which is wrong once the top bar wraps.
 */
(() => {
  const faded = document.querySelector('.faded-bg');
  const bar = document.querySelector('.headersection-2');
  if (!faded || !bar) return;

  const sync = () => {
    const top = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--faded-bg-top', `${top}px`);
  };

  try {
    sync();
    window.addEventListener('resize', sync, { passive: true });
    window.addEventListener('scroll', sync, { passive: true });
  } catch (error) {
    console.error('Error: .faded-bg', error);
  }
})();
